<template>
  <div></div>
</template>

<script>
import filters from "@/filters";
import {
  enterprise_setup,
  // local_api,
  // error_toast,
} from "@/utils";

export default {
  name: "CooldownRegister",
  components: {},
  filters: filters,
  data() {
    return {
      arg: "",
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {},
  mounted() {
    let vm = this;
    let arg = vm.$route.query.p;
    vm.arg = arg;

    //window.jQuery(vm.$refs.embed).embed();
    window.location =
      "https://latam.thecooldown.gg/age-gate?page=/desafio/corona";
  },
  created() {},
};
</script>

<style></style>
